import * as React from 'react';
import { RouteProps, Route } from 'react-router';
import { SpecificRequireProps } from '../RequirePermission';

interface RestrictedRouteProps extends RouteProps {
    restrictor: React.ComponentType<SpecificRequireProps>,
    notPermitted?: React.ReactElement,
}

const RestrictedRoute: React.FC<RestrictedRouteProps> = ({
    component,
    notPermitted,
    restrictor: Restrictor
    , ...rest 
}) => {
    const Component = component as React.ReactType;
    return (
        <Route {...rest} render={(props) => (
            <Restrictor notPermitted={notPermitted || (<h1>Access restricted!</h1>)}>
                <Component {...props}/>
            </Restrictor>)} 
        />
    );
}

export default RestrictedRoute;